import React from 'react';
import { Link } from '@blueprint/link';
import { RecentSalesLinkProps } from './RecentSalesLink.types';
import { trackClick } from './RecentSalesLink.tracking';

const RecentSalesLink = ({
    areaName,
    areaUri,
    trackingLabel
}: RecentSalesLinkProps) => {
    return (
        <Link
            href={`/house-prices/${areaUri}/?sold_price_years=1`}
            onClick={() => trackClick(trackingLabel)}
        >
            See all recent sales in {areaName}
        </Link>
    );
};

export default RecentSalesLink;
